// MPC1000 / JJOS .PRJ parser — plain-text manifest, CRLF-separated filenames.

export function parsePRJ(text) {
  const files = text
    .split(/\r\n|\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  return { kind: 'prj', files };
}
